module.exports = __webpack_public_path__ + "media/images/balance-prosperity-euro-7d32397c190c13c654987559bfeccdd3.png";